module.exports = require("@apollo/client/utilities");